/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询菜单列表
         * @param data
         * @return {*}
         */
        queryResourceList (data) {
            return http.json({
                url: '/system/resource/queryAll',
            })
        },

        /**
         * 查询菜单列表
         * @param data
         * @return {*}
         */
        queryResourceListByRoleId (data) {
            return http.json({
                url: '/system/resource/queryByRoleId?roleId='+data.roleId
            })
        },

        /**
         * 查询菜单详情
         * @param data
         * @return {*}
         */
        getResourceInfo (data){
            return http({
                url: `/system/resource/get?id=${data.id}`,
                method: 'post'
            });
        },

        /**
         * 保存菜单信息
         * @param data
         * @return {*}
         */
        saveResourceInfo (data){
            return http.json({
                url: '/system/resource/save',
                data
            });
        },

        /**
         * 删除菜单信息
         * @param data
         * @return {*}
         */
        removeResource(data) {
            return http.json({
                url: `/system/resource/delete?id=${data[0].id}`,
                data
            })
        },
        /**
         * 查询我的资源菜单
         */
        queryMyResource (){
            return http({
                url: '/system/resource/navigate',
                method: 'post'
            });
        },
        /**
         * 查询我的房间管理列表
         */
        queryFjglList (data) {
            return http.json({
                url: '/system/resource/fjglList',
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/resource.js